import { Modal } from 'almanac-ui/Modal'

import Styles from './BrandVoicePaywallModal.module.scss'

import { BrandVoicePaywallModalProps } from './Types'
import { Button } from 'components/Button'
import { Spinner } from 'common/Spinner/Spinner'
import { useState } from 'react'

export const CREATOR_BRAND_VOICE_LIMIT = 3

const BrandVoicePaywallModal = ({ isOpen, close, onUpgrade }: BrandVoicePaywallModalProps) => {
  const [isProcessing, setIsProcessing] = useState(false)

  const handlePress = async () => {
    setIsProcessing(true)
    await onUpgrade()
    setIsProcessing(false)
    close()
  }

  return (
    <Modal.Root>
      <Modal.Header title="Upgrade your plan" />
      <Modal.Content>
        The creator plan only allows {CREATOR_BRAND_VOICE_LIMIT} brand voices. You can upgrade to our{' '}
        <span className={Styles.bold}>Team plan</span> for unlimited brand voices.
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={close}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button onPress={handlePress} size="lg">
            {isProcessing && <Spinner data-testId="spinner" className={Styles.loadingSpinner} />}
            Upgrade
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { BrandVoicePaywallModal }
